import { extendTheme } from "@mui/joy/styles";

// Define the color palette to match the Material theme
const themeColors = {
  primary: "#145B99",
  secondary: "#6E759F",
  success: "#3b8917",
  warning: "#FFA319",
  error: "#FF1943",
  info: "#33C2FF",
  black: "#223354",
  white: "#ffffff"
};

export const JoyTheme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: "#e3f2fd",
          100: "#bbdefb",
          200: "#90caf9",
          300: "#64b5f6",
          400: "#42a5f5",
          500: themeColors.primary,
          600: "#1565c0",
          700: "#0d47a1",
          800: "#0a3d8a",
          900: "#072d6a",
          solidBg: themeColors.primary,
          solidHoverBg: "#0d4a7a",
          solidActiveBg: "#0a3d6a"
        },
        success: {
          50: "#e8f5e9",
          100: "#c8e6c9",
          200: "#a5d6a7",
          300: "#81c784",
          400: "#66bb6a",
          500: themeColors.success,
          600: "#2e7d32",
          700: "#1b5e20",
          800: "#145214",
          900: "#0d3d0d",
          solidBg: themeColors.success,
          solidHoverBg: "#2e7012",
          solidActiveBg: "#256010"
        },
        warning: {
          50: "#fff8e1",
          100: "#ffecb3",
          200: "#ffe082",
          300: "#ffd54f",
          400: "#ffca28",
          500: themeColors.warning,
          600: "#fb8c00",
          700: "#f57c00",
          800: "#ef6c00",
          900: "#e65100",
          solidBg: themeColors.warning,
          solidHoverBg: "#e59317",
          solidActiveBg: "#cc8315"
        },
        danger: {
          50: "#ffebee",
          100: "#ffcdd2",
          200: "#ef9a9a",
          300: "#e57373",
          400: "#ef5350",
          500: themeColors.error,
          600: "#e53935",
          700: "#d32f2f",
          800: "#c62828",
          900: "#b71c1c",
          solidBg: themeColors.error,
          solidHoverBg: "#e5163d",
          solidActiveBg: "#cc1436"
        },
        neutral: {
          50: "#f5f5f5",
          100: "#eeeeee",
          200: "#e0e0e0",
          300: "#bdbdbd",
          400: "#9e9e9e",
          500: themeColors.secondary,
          600: "#757575",
          700: "#616161",
          800: "#424242",
          900: "#212121",
          solidBg: themeColors.secondary,
          solidHoverBg: "#5d6488",
          solidActiveBg: "#4d5471"
        },
        background: {
          body: "#E9ECF3",
          surface: themeColors.white,
          popup: themeColors.white,
          level1: "#f5f5f5",
          level2: "#eeeeee",
          level3: "#e0e0e0"
        },
        text: {
          primary: themeColors.black,
          secondary: "rgba(34, 51, 84, 0.7)",
          tertiary: "rgba(34, 51, 84, 0.5)"
        },
        divider: "rgba(34, 51, 84, 0.1)"
      }
    }
  },
  fontFamily: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    display:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
  },
  components: {
    JoyButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          textTransform: "none",
          borderRadius: "6px"
        }
      }
    },
    JoyInput: {
      styleOverrides: {
        root: {
          borderRadius: "6px"
        }
      }
    },
    JoySheet: {
      styleOverrides: {
        root: {
          borderRadius: "10px"
        }
      }
    }
  }
});
